import { EditorEvent } from '../../../editor/types';

export abstract class LinkEditPluginEvent extends EditorEvent {
  protected constructor(type: string) {
    super('LinkPlugin', type);
  }
}

export class LinkEditBeforeOpen extends LinkEditPluginEvent {
  constructor() {
    super('pickerOpen');
  }
}

export class LinkEditClose extends LinkEditPluginEvent {
  constructor() {
    super('pickerClose');
  }
}

export type LinkEditPluginEvents = LinkEditBeforeOpen | LinkEditClose;
